exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hr-text{line-height:1em;position:relative;outline:0;border:0;color:#000;text-align:center;height:1.5em;opacity:.5}.hr-text:before{content:\"\";background:-webkit-gradient(linear,left top,right top,from(transparent),color-stop(#818078),to(transparent));background:linear-gradient(90deg,transparent,#818078,transparent);position:absolute;left:0;top:50%;width:100%;height:1px}.hr-text:after{content:attr(data-content);position:relative;display:inline-block;color:#000;padding:0 .5em;line-height:1.5em;color:#818078;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-356f1f68","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Users/LoginOrSignup/LoginOrSignup.vue
// module id = 883
// module chunks = 1 2